import { Box } from "@mui/material";
import StatCard from "./StatCard";

const stats = [
  {
    number: "10000+",
    title: "Satisfied clients",
    description: "Our awesome clients are industry experts around the world.",
  },
  {
    number: "06+",
    title: "Years experience",
  },
  {
    number: "30",
    title: "Professional designers",
  },
  {
    number: "20000+",
    title: "Digital Products",
  },
];

const StatisticSection = () => {
  return (
    <Box
      sx={{
        px: { xs: "16px", sm: "32px", md: "40px", lg: "48px" },
        py: { xs: "16px", sm: "24px", md: "32px" },
        mx: { xs: "16px", sm: "32px", md: "64px", lg: "96px" },
        position: { xs: "relative", md: "absolute" },
        top: { xs: "auto", md: "-120px", lg: "-95px" },
        transform: { xs: "translateY(-100px)", md: "none" },
        width: { xs: "auto", md: "85%", lg: "90%" },
        zIndex: 1000,
        marginBottom: { xs: "-80px", sm: "-100px" },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#000000",
          borderRadius: "48px",
          padding: { xs: "16px", sm: "19px", md: "19px" },
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          justifyContent: "space-between",
          gap: { xs: 2, sm: 2, md: 1 },
          overflow: "hidden",
        }}
      >
        {stats.map((stat, i) => (
          <StatCard key={i} stat={stat} index={i} isFirst={i === 0} />
        ))}
      </Box>
    </Box>
  );
};

export default StatisticSection;
